import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '@/shared/store';

type RoleState = {
  deleteRoleId: number | null;
};

const initialState: RoleState = {
  deleteRoleId: null,
};

const roleSlice = createSlice({
  name: 'role',
  initialState,
  reducers: {
    setDeleteRoleId(state, action: PayloadAction<number>) {
      state.deleteRoleId = action.payload;
    },
    clearDeleteRoleId(state) {
      state.deleteRoleId = null;
    },
  },
});

export const { setDeleteRoleId, clearDeleteRoleId } = roleSlice.actions;
export const selectDeleteRoleId = (state: RootState) =>
  state.role?.deleteRoleId;

export default roleSlice.reducer;
